import { useEntityAPI } from '../../../redux/entity-api.hook';
import { priceUnitsAPI } from '../redux/price-units.slice';

export function usePriceUnits() {
  return useEntityAPI(priceUnitsAPI);
}
